import { APICore } from "./apiCore";

const api = new APICore();

const baseUrl = process.env.REACT_APP_API_BASE_URL;
const CHARACTER_ENDPOINT = 'api/v1/admin/characters';

function searchCharacters(params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}`, params);
}

function createCharacterImageGenProfiles(characterId: string, data: any) {
    return api.create(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/image_gen_profiles`, data);
}

function getCharacterImageGenProfiles(characterId: string, params: any) {
    return api.get(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/image_gen_profiles`, params);
}

function updateCharacterImageGenProfile(characterId: string, imageId: string, params: any) {
    return api.update(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/image_gen_profiles/${imageId}`, params);
}

function deleteCharacterImageGenProfile(characterId: string, imageId: string) {
    return api.delete(`${baseUrl}/${CHARACTER_ENDPOINT}/${characterId}/image_gen_profiles/${imageId}`);
}


export {
    searchCharacters,
    createCharacterImageGenProfiles,
    getCharacterImageGenProfiles,
    updateCharacterImageGenProfile,
    deleteCharacterImageGenProfile
}




